"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "ACTION_DELETE_CONSUMER", {
  enumerable: true,
  get: function get() {
    return _consumers.ACTION_DELETE_CONSUMER;
  }
});

_Object$defineProperty(exports, "ACTION_DELETE_ENTITY", {
  enumerable: true,
  get: function get() {
    return _local.ACTION_DELETE_ENTITY;
  }
});

_Object$defineProperty(exports, "deleteConsumer", {
  enumerable: true,
  get: function get() {
    return _consumers.deleteConsumer;
  }
});

_Object$defineProperty(exports, "getConsumerActionCreators", {
  enumerable: true,
  get: function get() {
    return _consumers.getConsumerActionCreators;
  }
});

_Object$defineProperty(exports, "getCrudActionCreators", {
  enumerable: true,
  get: function get() {
    return _crud.getCrudActionCreators;
  }
});

_Object$defineProperty(exports, "getLocalActionCreators", {
  enumerable: true,
  get: function get() {
    return _local.getLocalActionCreators;
  }
});

_Object$defineProperty(exports, "pushRelateds", {
  enumerable: true,
  get: function get() {
    return _related.pushRelateds;
  }
});

_Object$defineProperty(exports, "removeItem", {
  enumerable: true,
  get: function get() {
    return _local.removeItem;
  }
});

_Object$defineProperty(exports, "touchEtag", {
  enumerable: true,
  get: function get() {
    return _crud.touchEtag;
  }
});

var _crud = require("./crud");

var _local = require("./local");

var _consumers = require("./consumers");

var _related = require("./related");